module.exports = __webpack_public_path__ + "img/7.cd604437.png";